module.exports = __webpack_public_path__ + "3a111ed08d5605003ac55a2f00546f05.png";